var render, staticRenderFns
import script from "./actionForm.vue?vue&type=script&lang=js"
export * from "./actionForm.vue?vue&type=script&lang=js"
import style0 from "./actionForm.vue?vue&type=style&index=0&id=2e2985e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2985e6",
  null
  
)

export default component.exports